
import { getElements, getClasses } from './components.site-navigation';

const $ = jQuery;

var initialised = false,
	elements,
	classes;

export function navIsInitialised() {
	return initialised;
}

function uncheckAllCheckboxes() {
	elements.$navSubNavCheckboxes.attr('checked', false);
}

function removeAllActiveClasses() {
	elements.$subNavLabels.removeClass(classes.isActive);
}

export function reset() {

	if ( navIsInitialised() ) {

		initialised = false;

		uncheckAllCheckboxes();
		removeAllActiveClasses();

		elements.$subNav.attr('style', '');
		elements.$subSubNav.attr('style', '');
	}
}

function handleLabelClick(e) {
	
	const 	$clickedElem = $(e.currentTarget),
			$clickedElemLinkHref = $clickedElem.siblings('a').attr('href');

	if ( $clickedElem.hasClass(classes.isActive) && $(e.target).hasClass('js-label-text') && $clickedElemLinkHref !== '#' ) {
		window.location = $clickedElemLinkHref;
	} else {
		$clickedElem.toggleClass(classes.isActive);
	}
}

function addEventListeners() {
	elements.$subNavLabels.on('click', handleLabelClick);
}

export function init() {

	elements = getElements();
	classes = getClasses();

	if ( ! navIsInitialised() ) {

		elements.$subNav.css('opacity', 1);
		elements.$subSubNav.css('opacity', 1);

		initialised = true;

		addEventListeners();
	}
}